import * as DAOUtils from "../utils/DAOUtils";

export function getStatuses() {
  return DAOUtils.get("/worklists/workListItemStatesDictionary");
}
